import store from '@/store/'
import * as keys from '@/router/router-keys'

// GlobalEventHandlers
window.onfocus = async function () {
  const now = new Date()

  // get current session age in minutes
  const sessionAge = (now - new Date(store.state.auth.timestamp)) / 1000 / 60

  // get session duration from vue/.env =/* * 0.85 */
  const sessionLifetime = parseInt(process.env.VUE_APP_LARAVEL_SESSION_LIFETIME)

  if (sessionAge > sessionLifetime && store.state.auth.timestamp) {
    sessionStorage.setItem(keys.LS_ROUTE_EXPIRED_SESSION, JSON.stringify(true))
    sessionStorage.setItem(keys.LS_ROUTE_KEY, JSON.stringify(store.state.route))
    sessionStorage.setItem(keys.LAST_USER, JSON.stringify(store.state.user.id))
    await store.dispatch('auth/AUTH_REFRESH')
  }
  // console.log({ sessionLifetime: sessionLifetime, sessionAge: sessionAge })
}
